import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initAmplitude } from './lib/analytics'
import { initWebVitals } from './lib/webVitals'
import { installGlobalErrorHandlers } from './lib/errorReporting'
import { ErrorBoundary } from './components/ErrorBoundary'

initAmplitude();
initWebVitals();
installGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
